<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  name: "referrer",
  props: {
    referrerData: Array,
  },
  mounted() {
    this.render();
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "",
            data: [],
          },
        ],
      },
      options: {
        tooltips: {
          callbacks: {
            footer: (tooltipItems) => {
              let total = tooltipItems.reduce(
                (a, e) => a + parseInt(e.xLabel),
                0
              );
              return "Total: " + total;
            },
          },
        },
        scales: {
          yAxes: [
            {
              stacked: true,
            },
          ],
          xAxes: [
            {
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1,
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  watch: {
    // call again the method if the route changes
    $route: "referrer",
    referrerData: "render",
  },
  methods: {
    render() {
      const totalDataset = {};
      const uniqueDataset = {};

      if (this.referrerData !== null) {
        this.referrerData.forEach((current) => {
          var referrers = current.referrers;
          if (referrers) {
            referrers.forEach((referrer) => {
              if (!totalDataset[referrer.name]) {
                totalDataset[referrer.name] = 0;
                uniqueDataset[referrer.name] = 0;
              }

              totalDataset[referrer.name] += referrer.count || 0;
              uniqueDataset[referrer.name] += referrer.uniques || 0;
            });
          }
        });
      }

      const nonUniqueDataset = {};
      Object.keys(totalDataset).forEach((referrer) => {
        nonUniqueDataset[referrer] =
          totalDataset[referrer] - uniqueDataset[referrer];
      });

      const sortable = [];
      Object.keys(nonUniqueDataset).forEach((key) => {
        sortable.push({
          key,
          nonUnique: nonUniqueDataset[key],
          unique: uniqueDataset[key],
        });
      });

      sortable.sort((a, b) => {
        return b.nonUnique + b.unique - (a.nonUnique + a.unique);
      });

      const sortedKeys = [];
      const sortedNonUnique = [];
      const sortedUnique = [];
      sortable.forEach((item) => {
        sortedKeys.push(item.key);
        sortedNonUnique.push(item.nonUnique);
        sortedUnique.push(item.unique);
      });

      this.chartData = {
        labels: sortedKeys,
        datasets: [
          {
            label: "Unique referrals",
            data: sortedUnique,
            backgroundColor: "#6AB2F5",
          },
          {
            label: "Non-unique referrals",
            data: sortedNonUnique,
            backgroundColor: "#f56a6a",
          },
        ],
      };

      this.renderChart(this.chartData, this.options);
    },
  },
};
</script>
